module.exports = __webpack_public_path__ + "static/img/1009_small.1ad52f0.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/1009_small.png
// module id = lx29
// module chunks = 1